/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {IUser} from '../User';
import {UserService} from '../../../services/user.service';
import {permissions} from '../../../permissions';
import {UserStatusService} from '../user-status/user-status.service';
import {Title} from '@angular/platform-browser';

@Component({
  templateUrl: 'profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [
    UserStatusService
  ]
})
export class ProfileComponent implements OnInit {

  properties;
  public permissions = permissions;

  public user: IUser;

  constructor(
      private authService: AuthService,
      private router: Router,
      private route: ActivatedRoute,
      private userService: UserService,
      private title: Title
  ) {
      this.user = this.userService.initialize();
      this.title.setTitle('User Profile');
  }

  ngOnInit() {
    const userId = this.route.snapshot.params.id || this.authService.userId;
    this.userService.getById(userId).subscribe( user => {
       this.user = user;
    });
  }

  editCustomer() {
    this.router.navigate(['user/profile/edit/' + this.user.id]);
  }

  changePassword() {
    this.router.navigate(['user/change-password/' + this.user.id]);
  }

  adminChangePassword() {
    this.router.navigate(['user/admin-change-password/' + this.user.id]);
  }

  editPermissions(){
    this.router.navigate(['user/permissions/' + this.user.id]);
  }

  editRoles(){
    this.router.navigate(['user/roles/' + this.user.id]);
  }

  editAccess(){
    this.router.navigate(['user/access/' + this.user.id]);
  }

  editOesAccess() {
    this.router.navigate(['user/oes-access/' + this.user.id]);
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/profile/profile.component.ts